<script setup>
import _ from 'lodash-es'
import { useI18n } from 'vue-i18n'
import AuthLayout from '../layout/AuthLayout.vue'
import { reactive, ref } from 'vue'
import { get, isValidPassword, post,toJson,validators } from '@/common/util'
import { useMetaStore } from '@/stores'
import locales from '@/common/locales'
import dayjs from 'dayjs'
const i18n=useI18n(),meta=reactive({}),currStep=ref(1),postdata=reactive({}),stepper=ref(null),btnprev=ref(null),btnnext=ref(null),metaStore=useMetaStore(),siteName=ref('맵오')
,stepitems=['acceptterms','enterinformation','signedup']
,agreeModel=reactive({magreeservice:false,agreeprivacy:false,magreeprivacy_req:false,magreethirdparty:false,agreemarketing:false,agreemail:false,agreesmssns:false})
,memberinfo=reactive({id:{mandatory:true,holderkey:'pleaseenteryourid'},email:{mandatory:true,holderkey:'pleaseenteryouremail'}
  ,passwd:{mandatory:true,holderkey:'pleasecheckyourpasswordsafetyrules'},confirmpassword:{mandatory:true,holderkey:'pleaseenteryourpasswordonemoretime'}
  ,name:{mandatory:true,holderkey:'enteraname'},companyperiodname:{holderkey:'pleaseenteryourcompanyperiodname'},contact:{holderkey:'pleaseenteryourpriorityphoneorcellphonenumber'}
  ,departmentname:{holderkey:'pleaseenteradepartmentname'},jobtitle:{holderkey:'pleaseenteryourjobtitle'}}),terms=reactive({ison:false,ttlkey:'',cont:''})
,disableNext=()=>{
  if(!stepper.value)return false
  let disabled=false
  if(currStep.value==1&&!_.entries(agreeModel).filter(ent=>ent[0].startsWith('m')).every(ent=>ent[1]))disabled=true
  if(currStep.value==2){
    const mandatories=_.entries(memberinfo).filter(ent=>ent[1].mandatory)
    if(mandatories.length==0||mandatories.some(ent=>_.isEmpty(ent[1].modelValue))
      ||memberinfo.passwd.modelValue!=memberinfo.confirmpassword.modelValue||validators.email(memberinfo.email.modelValue)!==true)disabled=true
    if(isValidPassword(memberinfo.passwd.modelValue)!==true)disabled=true
  }
  return disabled
},termsPop=async key=>{
  terms.ttlkey=key
  metaStore.blockLoading()
  if(key.startsWith('privacyconsent')){
    const res=await get('rest/public/conf/'+key)
    if(res.data)terms.cont=res.data.tval
    else terms.cont=''
  }else{
    const res=await get('rest/public/termsofsites/'+key)
    const current=res.data.filter(term=>term.sdt).find(term=>dayjs(term.sdt).isBefore(dayjs()))
    if(current)terms.cont=current.cont
    else terms.cont=''
  }
  metaStore.blockLoading(false)
  terms.ison=false
  metaStore.pop({ison:true,callback:()=>terms.ison=true})
},genRules=key=>{
  const rslt=[]
  if(memberinfo[key].mandatory)rslt.push(validators.required)
  if(key=='passwd'){
    rslt.push(isValidPassword)
  }else if(key=='confirmpassword')rslt.push(v=>validators.retypeBefore(memberinfo.passwd.modelValue,v,'checksamepasscon'))
  else if(key=='email')rslt.push(validators.email)
  return rslt
},prepareMem=()=>{
  postdata.agreeprivacy=agreeModel.agreeprivacy
  postdata.agreedemailads=agreeModel.agreemail
  postdata.agreedsnssmsads=agreeModel.agreesmssns
  postdata.mid=memberinfo.id.modelValue
  postdata.mid=memberinfo.id.modelValue
  postdata.email=memberinfo.email.modelValue
  postdata.passwd=memberinfo.passwd.modelValue
  postdata.mname=memberinfo.name.modelValue
  postdata.company=memberinfo.companyperiodname.modelValue
  postdata.contact=memberinfo.contact.modelValue
  postdata.dept=memberinfo.departmentname.modelValue
  postdata.jobtitle=memberinfo.jobtitle.modelValue
  postdata.localecode=locales.find(loc=>loc.key.toLowerCase().includes(i18n.locale.value)).key
  if(postdata.authcode)postdata.authcode=postdata.authcode
  return toJson(postdata)
},alertMsg=(txt,isErr)=>{
  meta.alerttxt=i18n.t(txt)
  meta.alertoverlay=true
  meta.alerttype=!isErr
},checkAuthCodeAndSignup=()=>{
  if(_.isEmpty(postdata.authcode)||postdata.authcode.length!=6)return alertMsg('pleaseenteryourverificationnumber',true)
  metaStore.blockLoading()
  post('rest/public/checkauthcodeandsignup',prepareMem(),resp=>{
    metaStore.blockLoading(false)
    if(!resp.isSuccess)return alertMsg('wrong_verification_code')
    currStep.value=4
  })
  meta.emailauthconfirmed=true
},sendAuthCode=isretry=>{
  if(memberinfo.id.modelValue.includes('<=>'))return alertMsg('invalidtxtcontain',true)
  metaStore.blockLoading()
  post('rest/public/'+(isretry?'re':'')+'publishauth',prepareMem(),resp=>{
    metaStore.blockLoading(false)
    if(resp.isSuccess){
      currStep.value=3
    }else alertMsg(resp.msg)
  })
},actNext=()=>{
  if(currStep.value==2&&meta.emailenabled)return sendAuthCode()
  if(currStep.value==2&&!meta.emailenabled){
    metaStore.blockLoading()
    setTimeout(() => {
      post('rest/public/justsignup',prepareMem(),resp=>{
        metaStore.blockLoading(false)
        if(!resp.isSuccess)return alertMsg(resp.msg)
        currStep.value=3
      })
    }, 300);
    return
  }
  currStep.value++
}
get('rest/public/conf/site_nm',res=>{
  if(res.isSuccess)siteName.value=res.data.sval
})
get('rest/public/emailenabled',res=>{
  if(res.data)stepitems.value.splice(2,0,'emailauthentication')
  meta.emailenabled=res.data
})
</script>
<template>
  <AuthLayout v-if="meta.emailenabled!==undefined">
    <template #body>
      <v-overlay contained :model-value="meta.alertoverlay" class="align-center justify-center" @click:outside="meta.alertoverlay=false">
        <v-alert class="bg-white" closable :model-value="meta.alertoverlay" :text="meta.alerttxt" variant="outlined" :type="meta.alerttype?'info':'error'" @click:close="meta.alertoverlay=false"/>
      </v-overlay>
      <v-stepper ref="stepper" v-model="currStep" alt-labels hide-actions>
        <template #default="{ prev, next }">
          <v-stepper-header>
            <template v-for="num in stepitems.length" :key="num">
              <v-stepper-item :value="num">{{ metaStore.t(stepitems[num-1]) }}</v-stepper-item>
              <v-divider v-if="num !== stepitems.length" :key="num"/>
            </template>
          </v-stepper-header>
          <v-stepper-window>
            <v-stepper-window-item v-for="num in stepitems.length" :value="num">
              <v-card v-if="num==1" flat :title="$t('hello')+'!'">
                <div class="text-h7 ms-4 mb-3">{{ $t('pleaseacceptthetermstosignupforsite').replace('_sitename_',siteName) }}</div>
                <v-checkbox hide-details :label="$t('acceptthetermsintheirentiretyincludingoptinconsent')" class="pa-0"
                  :model-value="_.values(agreeModel).every(val=>val)" @update:modelValue="checked=>_.keys(agreeModel).forEach(key=>agreeModel[key]=checked)"/>
                <div class="ml-7">
                  <v-row no-gutters v-for="item in [{tk:'termsofservice',key:'magreeservice',mandatory:true,detail:'termsofuse'},{tk:'privacyconsent_required',key:'magreeprivacy_req',detail:'privacyconsent_required'}
                    ,{tk:'privacyconsent_optional',key:'agreeprivacy',detail:'privacyconsent_optional'},{tk:'locationterms',key:'magreethirdparty',mandatory:true,detail:'locationterms'}
                    ,{tk:'marketingconsent',key:'agreemarketing'},{tk:'consenttoreceiveemails',key:'agreemail'},{tk:'marketingconsentsmssns',key:'agreesmssns'}]">
                    <v-col>
                      <v-checkbox hide-details :class="(item.key=='agreemail'||item.key=='agreesmssns')?'ml-7':''" v-model="agreeModel[item.key]" :label="$t(item.tk)+(item.mandatory?'('+$t('mandatory')+')':'')"
                        @update:model-value="val=>{if(item.key=='agreemarketing')['agreemail','agreesmssns'].forEach(key=>agreeModel[key]=val)}"/>
                    </v-col>
                    <v-col v-if="item.detail" cols="2" class="pt-3"><a href="#" @click="termsPop(item.detail)">{{ $t('viewall') }}</a></v-col>
                  </v-row>
                </div>
              </v-card>
              <v-card v-if="num==2" flat>
                <v-card-text class="pt-5">
                  <v-row v-for="key in _.keys(memberinfo)">
                    <v-col cols="12" class="position-relative pt-0" :style="key=='departmentname'||key=='jobtitle'?'display:none;':''">
                      <v-text-field :type="(key=='passwd'||key=='confirmpassword')?'password':'text'" density="compact" v-model="memberinfo[key].modelValue" :label="$t(key)+(memberinfo[key].mandatory?' *':'')"
                        variant="outlined" :rules="genRules(key)"  :placeholder="$t(memberinfo[key].holderkey)" :hide-details="!memberinfo[key].mandatory"/>
                      <template v-if="key=='passwd'">
                        <v-btn density="compact" icon="mdi-exclamation" class="position-absolute passwdguide" style="top: -20px;right: 14px;"/>
                        <v-tooltip activator=".passwdguide" location="top">
                          <v-list lines="one">
                            <v-list-item :title="$t('checkitout')+' '+$t('passwordsafetyrules')">
                              {{ $t('useatleast8charactersandatleasttwoofthefollowingupperandlowercaselettersnumbersandspecialcharacters') }}<br/>
                              {{ $t('nomorethan4consecutivecharactersdigitsofthesameletternumber1111aaaetc') }}<br/>
                              {{ $t('cantusemorethan3charactersonthekeyboardqweretc') }}<br/>
                              {{ $t('avoidusingthesamenumberasyourdateofbirthandphonenumber') }}
                            </v-list-item>
                          </v-list>
                        </v-tooltip>
                      </template>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              <v-card v-if="num==3&&meta.emailenabled" flat variant="outlined" class="py-8 px-6 text-center mx-auto ma-4" max-width="400" width="100%">
                <h3 class="text-h6 mb-4">{{$t('wehavesentaverificationnumbertotheemailyouprovided')}}</h3>
                <div class="text-body-2">
                  {{$t('entertheverificationnumberintheemailyoureceived')}}
                </div>
                <v-sheet color="surface">
                  <v-otp-input v-model="postdata.authcode" variant="solo" error/>
                </v-sheet>
                <v-btn color="primary" height="40" :text="$t('enteryourverificationnumber')" variant="flat" width="80%" @click="checkAuthCodeAndSignup()"/>
                <div class="text-caption">
                  {{ $t('didNotReceiveCode') }} <a href="#" @click.prevent="postdata.authcode = '';sendAuthCode(true);alertMsg('wehavesentaverificationnumbertotheemailyouprovided')">{{ $t('resend') }}</a>
                </div>
              </v-card>
              <v-card v-if="num==stepitems.length" flat>
                <h2 class="text-center pa-10">{{ $t('yoursignupiscomplete') }}</h2>
                <v-btn block color="primary" @click="$router.push('login')">{{ $t('gotologin') }}</v-btn>
              </v-card>
            </v-stepper-window-item>
          </v-stepper-window>
        </template>
      </v-stepper>
    </template>
    <template #actions>
      <v-row v-if="currStep<3">
        <v-col cols="6">
          <v-btn ref="btnprev" variant="outlined" @click="currStep--" :disabled="currStep==1">{{ $t('previous') }}</v-btn>
        </v-col>
        <v-col cols="6" class="text-right">
          <v-btn ref="btnnext" variant="flat" color="primary" @click="actNext" :disabled="disableNext()">{{ $t('next') }}</v-btn>
        </v-col>
      </v-row>
    </template>
  </AuthLayout>
  <Teleport v-if="terms.ison" to="#popbody">
    <v-card style="position: relative;">
      <v-btn variant="text" icon="mdi-close" style="position: absolute;right: 0;" @click="metaStore.pop({ison:false})"/>
        <v-card-title class="text-center">{{$t(terms.ttlkey)}}</v-card-title>
        <v-card-text>
          <div style="width: 40vw;height: 50vh;overflow-y: auto;" v-html="terms.cont"/>
        </v-card-text>
      </v-card>
  </Teleport>
</template>
<style>
.step1 .v-selection-control{min-height: 20px !important;}
.v-tooltip .v-overlay__content{background-color: #fff !important;border: 1px solid #eee;}
.v-card-title,.v-card-subtitle{text-wrap-mode: wrap;}
</style>
